import React from "react";
import { Link } from "react-router-dom";
import { handymanServiceCategories } from "../data/handymanServices";

const ServicesSection: React.FC = () => {
  const categories = Object.entries(handymanServiceCategories);

  return (
    <section className="py-10 px-4 max-w-screen-xl mx-auto">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800">
          Services We Cover
        </h2>
        <p className="text-gray-500 mt-2">
          Browse by category, or search directly for what you need.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {categories.map(([category, services]) => (
          <div key={category}>
            <h3 className="font-semibold text-gray-900 mb-3 pb-2 border-b border-gray-200">
              {category}
            </h3>
            <div className="flex flex-wrap gap-2">
              {services.map((service) => (
                <Link
                  key={service}
                  to="/search"
                  className="text-sm px-3 py-1 rounded-full bg-gray-100 text-gray-700 hover:bg-yellow-500 hover:text-white transition duration-200"
                >
                  {service}
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServicesSection;
